<template>
    <div class="main">
        <c-panel title="INDICADORES PREDITIVOS" titleIcon="fas fa-brain">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Configurações de risco de evasão e de reprovação."
                description="Cada configuração define o que se prevê, sobre quais turmas e com que limiares. O modelo precisa ser treinado com o histórico da rede antes de calcular scores."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="8">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.objetivo" clearable placeholder="Objetivo" style="width: 100%;" @change="carregar">
                        <el-option value="evasao" label="Evasão"></el-option>
                        <el-option value="reprovacao" label="Reprovação"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.periodo_letivo_id" clearable placeholder="Período" style="width: 100%;" @change="carregar">
                        <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/preditivo/configuracao/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVA CONFIGURAÇÃO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Configuração</th>
                            <th style="width: 150px;">Objetivo</th>
                            <th style="width: 190px;" class="u-text-center">Modelo</th>
                            <th style="width: 140px;" class="u-text-center">Último cálculo</th>
                            <th style="width: 100px;" class="u-text-center">Situação</th>
                            <th style="width: 190px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="c in items" :key="c.id">
                            <td>
                                {{ c.nome }}
                                <div><small class="u-text-muted">limiares: alto ≥ {{ pct(c.limiar_alto) }} · médio ≥ {{ pct(c.limiar_medio) }}</small></div>
                            </td>
                            <td>{{ c.rotulo_objetivo }}</td>
                            <td class="u-text-center">
                                <template v-if="c.tem_modelo">
                                    <el-tag size="mini" type="success">{{ c.modelo_versao }}</el-tag>
                                    <div v-if="c.modelo_acuracia">
                                        <small class="u-text-muted">acurácia {{ pct(c.modelo_acuracia) }}</small>
                                    </div>
                                </template>
                                <el-tag v-else size="mini" type="info">não treinado</el-tag>
                            </td>
                            <td class="u-text-center">{{ c.ultimo_calculo ? dataBr(c.ultimo_calculo) : '—' }}</td>
                            <td class="u-text-center">{{ c.situacao ? 'Ativa' : 'Inativa' }}</td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/preditivo/painel?configuracao=' + c.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button size="mini" plain title="Abrir painel" icon="el-icon-data-analysis"></el-button>
                                </router-link>
                                <router-link v-if="podeEscrever" :to="'/admin/preditivo/configuracao/edit/' + c.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(c.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="6" class="u-text-center">Nenhuma configuração cadastrada.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO K — item 138. Interface para `api/preditivo/configuracao`. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        statusList: false, filtro: { nome: '', objetivo: '', periodo_letivo_id: '' },
        items: []
    }),
    computed: {
        /** Configuração preditiva é decisão de política da rede. */
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.carregar()
    },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/preditivo/configuracao/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        pct (v) { return v !== null && v !== undefined ? (parseFloat(v) * 100).toFixed(0) + '%' : '—' },
        dataBr (d) {
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]}`
        },
        excluir (id) {
            this.$confirm('Excluir esta configuração?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/preditivo/configuracao/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Configuração excluída.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
